import { render, staticRenderFns } from "./EditInfoButton.vue?vue&type=template&id=3ad7c622&"
import script from "./EditInfoButton.vue?vue&type=script&lang=js&"
export * from "./EditInfoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports